/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerDocEnums;

(function (BrokerDocEnums) {
  BrokerDocEnums["TOBA"] = "toba";
  BrokerDocEnums["PRIVACY_POLICY"] = "privacy_policy";
})(BrokerDocEnums || (BrokerDocEnums = {}));